export const INVENTAR_FELDER = {
  Elektro: {
    Messgeräte: ["Prüftermin", "Kalibriert", "Messbereich"],
    Maschinen: ["Leistung (W)", "Spannung (V)", "Baujahr", "Zubehör"],
    Spezialwerkzeug: ["Typ", "Anwendungsgebiet", "Hersteller"],
    Haushaltsgeräte: ["Energieklasse", "Leistung (W)", "StandortRaum"],
  },
  PV: {
    Wechselrichter: ["Leistung (kW)", "Phasen", "Firmware"],
    Solarmodule: ["Leistung (Wp)", "Zelltyp", "Spannung"],
    Elektronik: ["Typ", "Funktion"],
    Unterkonstruktion: ["Material", "Montageart", "Länge (m)"],
    Speicher: ["Kapazität (kWh)", "Batterietyp", "Seriennummer"],
  },
  Sicherheit: {
    Alarm: ["Zentralentyp", "Zonen", "Firmware", "Spannung"],
    Video: ["Auflösung (MP)", "Objektivtyp", "IP-Adresse"],
  },
  Ladestation: {
    Wallboxen: ["Leistung (kW)", "Ladeanschluss", "Kabeltyp", "Firmware"],
  },
   Ladenbau: {
    Möbel: ["Position", "Material", "Farbe", "Abmessungen"],
    Beleuchtung: ["Leistung (W)", "Lichtfarbe (K)", "Leuchten-Typ"],
    Beschriftung: ["Typ", "Text", "Montageart"],
    Dekoration: ["Art", "Farbe", "StandortRaum"],
  },
  Intern: {
    Fahrzeuge: ["Kennzeichen", "Marke", "Modell", "Kilometer", "ServiceDatum", "Fahrer"],
    "El. Geräte": ["Gerätetyp", "Leistung (W)", "Seriennummer", "StandortRaum"],
  },
};
